<template>
    <div>
        <van-popup v-model="show" @click-overlay="close">
            <div class="tips_pop">
                <div class="tips_top">
                    <div class="tips_title">
                        <img src="@/assets/redPacket/bg_voucher.png" />
                    </div>
                    <div class="tips_close" @click="close">
                        <i class="iconfont icon-s-cuowu-guanbi"></i>
                    </div>
                </div>
                <div class="tips_box">
                    <div class="tips">{{ $t("RedemptionCode.tips1") }}</div>
                    <div class="platforms_icons">
                        <img v-for="(item, index) in platforms.slice(0, 3)" :key="index" :src="item.icon" @click="onNavTo({ url: item.url, type: 'href' })" />
                    </div>
                    <a-input v-model="code" :placeholder="$t('RedemptionCode.PleaseEnterTheRedemptionCode')"></a-input>
                </div>
                <div class="tips_footer" @click="confirm">
                    {{ $t("RedemptionCode.exchange") }}
                </div>
            </div>
        </van-popup>
        <upBonusPopup ref="upBonusPopup" @getNormalReward="onReceiveReward"></upBonusPopup>
    </div>
</template>

<script>
import { getDrawDown, getRedEnvelopeDetail } from '@/api/bonusCenter'
import upBonusPopup from '@/views/weeklySalary/modules/upBonusPopup.vue'
import { Toast } from 'vant'
export default {
    props: {
        tips: {
            type: String,
            default: ''
        },
        tips2: {
            type: String,
            default: ''
        }
    },
    components: { upBonusPopup },
    computed: {
        sysConfig() {
            return this.$store.getters.sysConfig
        }
    },
    watch: {
        sysConfig: {
            handler: function (newVal, oldVal) {
                if (newVal) {
                    this.GetPlatforms()
                }
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            show: false,
            code: '',
            platforms: [],
            isCanReceiveReward: true
        }
    },
    methods: {
        close() {
            this.show = false
            this.$emit('close')
        },
        open() {
            this.show = true
            const code = this.$store.state.user.redEnvelopeCode
            if (code) this.code = code
            this.GetPlatforms()
        },
        confirm() {
            const that = this
            if (!that.code) {
                Toast(that.$t('RedemptionCode.PleaseEnterTheRedemptionCode2'))
                return
            }
            const params = {
                code: that.code.trim()
            }
            getRedEnvelopeDetail(params).then((res1) => {
                if (res1.code) return
                const D1 = res1.result
                if (D1.bonusCanLevelUp === 'Yes') {
                    const item = {
                        type: 'redEnvelope',
                        amount: D1.singleAmt,
                        levelUpAmount: D1.bonusLevelUpBonusAmt,
                        rewardRecordId: D1.redEnvelopeId,
                        rewardState: 'canClaim',
                        upgradeBonusLevelUpRechargeAmt: D1.bonusLevelUpRechargeAmt,
                        depositType: 'redEnvelope'
                    }
                    that.$refs.upBonusPopup.open(item)
                } else {
                    that.onReceiveReward()
                    that.$emit('confirm')
                }
            })
        },
        onReceiveReward() {
            const that = this
            if (that.isCanReceiveReward) {
                that.isCanReceiveReward = false
                const params = {
                    code: that.code.trim()
                }
                getDrawDown(params).then((res) => {
                    if (res.code) return
                    that.$store.dispatch('user/setRedEnvelopeCode', '')
                    that.close()
                    Toast(res.message)
                }).finally(() => {
                    that.isCanReceiveReward = true
                })
            }
        },
        GetPlatforms() {
            this.platforms = []
            const systemConfig = this.sysConfig
            if (!systemConfig) return
            const whatsapp = systemConfig.whatsapp?.trim()
            if (whatsapp) {
                const platform5 = {
                    id: 4,
                    icon: require('@/assets/share/icon_whatsapp.png'),
                    title: 'Whatsapp',
                    url: whatsapp,
                    linkType: 'href'
                }
                this.platforms.push(platform5)
            }
            const telegramGroup = systemConfig.telegramGroup?.trim()
            if (telegramGroup) {
                const platform8 = {
                    id: 1,
                    icon: require('@/assets/share/icon_telegram.png'),
                    title: 'Telegram',
                    url: telegramGroup,
                    linkType: 'href'
                }
                this.platforms.push(platform8)
            }
            const instagram = systemConfig.instagram?.trim()
            if (instagram) {
                const platform3 = {
                    id: 2,
                    icon: require('@/assets/share/icon_ins.png'),
                    title: 'Instagram',
                    url: instagram,
                    linkType: 'href'
                }
                this.platforms.push(platform3)
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';
.van-popup {
    background: transparent;
}

.tips_pop {
    padding: .52rem;
    padding-top: 0;
    box-sizing: border-box;
    width: min(6.9rem, calc(100vw - 24px));
    background: $bg-popup-color;
    border-radius: .2rem;
    margin: 0 auto;
    padding-bottom: .06rem;
    height: auto;
    padding-bottom: .28rem;

    .tips_top {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        // margin: 0 .3rem;
        position: relative;
        z-index: 0;

        .tips_title {
            font-weight: 400;
            font-size: .28rem;
            color: var(--aurora-ink);
            font-size: .24rem;

            & > img{
                width: 100%;
                height: auto;
            }
        }

        .tips_close {
            width: .42rem;
            height: .42rem;
            cursor: pointer;
            color: var(--aurora-ink);
            position: absolute;
            right: -.22rem;
            top: .2rem;
            i{
                font-size: .38rem;
                font-weight: 400;
            }
        }
    }

    .tips_box {
        margin: .4rem auto;
        font-size: .24rem;
        position: relative;
        z-index: 1;
        margin-top: -1.38rem;

        .tips{
            text-align: center;
            color: var(--aurora-ink);
            font-size: .24rem;
            font-weight: bold;
            margin: .2rem;
            box-sizing: border-box;
        }

        .platforms_icons{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-around;
            margin: .28rem 0;
            margin-bottom: .52rem;

            & > img{
                width: .88rem;
                height: .88rem;
            }
        }

        .tips2 {
            margin-top: .2rem;
        }

        ::v-deep input::-webkit-outer-spin-button {
            -webkit-appearance: none;
        }

        ::v-deep input::-webkit-inner-spin-button {
            -webkit-appearance: none;
        }

        ::v-deep input[type='number'] {
            -moz-appearance: textfield;
        }

        ::v-deep .ant-input {
            background: $bg-input-color !important;
            border-radius: 0.14rem;
            font-size: 0.22rem;
            height: .8rem;
            padding: 0px 0.24rem !important;
            color: var(--aurora-ink);
            border: .02rem solid $border-input-color !important;
            padding-left: .2rem !important;

            &:focus {
                background: $bg-input-act-color;
                border-color: $border-active-color !important;
            }

            &::-webkit-input-placeholder {
                /* WebKit browsers */
                font-size: .22rem;
                color: $font-placeholder-color;
                opacity: .7;
                font-weight: 100;
            }

            &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                font-size: .22rem;
                color: $font-placeholder-color;
            }

            &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                font-size: .22rem;
                color: $font-placeholder-color;
            }

            &:-ms-input-placeholder {
                /* Internet Explorer 10+ */
                font-size: .22rem;
                color: $font-placeholder-color;
            }

        }
    }

    .tips_footer {
        width: 100%;
        box-sizing: border-box;
        height: .7rem;
        background: $bg-btn-color;
        line-height: .7rem;
        text-align: center;
        font-size: .3rem;
        font-weight: bold;
        color: $font-btn-color;
        cursor: pointer;
        border-radius: .16rem;
    }
}
</style>
